import type { PropType } from "vue";

import { type ColorType, type SizeType, State } from "@/abc-dsk/options";
import { color as defaultColor, size as defaultSize } from "@/abc-dsk/props";

import { Variant } from "./common";

type SizeProps = {
  size: SizeType;
  sizeSm?: SizeType;
  sizeMd?: SizeType;
  sizeLg?: SizeType;
  sizeXl?: SizeType;
  sizeXxl?: SizeType;
};

export const color = {
  type: String as PropType<ColorType | "white">,
  default: defaultColor.default
};

export const size = {
  type: String as PropType<SizeType>,
  default: defaultSize.default
};

export const sizeSm = {
  type: String as PropType<SizeType>,
  default: (props: SizeProps) => props.size
};

export const sizeMd = {
  type: String as PropType<SizeType>,
  default: (props: SizeProps) => props.sizeSm
};

export const sizeLg = {
  type: String as PropType<SizeType>,
  default: (props: SizeProps) => props.sizeMd
};

export const sizeXl = {
  type: String as PropType<SizeType>,
  default: (props: SizeProps) => props.sizeLg
};

export const sizeXxl = {
  type: String as PropType<SizeType>,
  default: (props: SizeProps) => props.sizeXl
};

type Tag = "button" | "a" | "router-link";
export const tag = {
  type: String as PropType<Tag>,
  default: "button"
};

export const state = {
  type: String as PropType<State>,
  default: State.None
};

type VariantType = `${Variant}`;
export const variant = {
  type: String as PropType<VariantType>,
  default: Variant.Solid
};

export const fullWidth = {
  type: Boolean,
  default: false
};
